import React from "react";
import { ArrowUp, ArrowDown, X } from "lucide-react";

const iconBtn =
  "h-8 w-8 sm:h-9 sm:w-9 inline-flex items-center justify-center rounded border text-slate-600 hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed";

export default function StopsList({ stops, onReorder, onRemoveStop, onStopClick, testIdPrefix: p }) {
  return (
    <ol className="space-y-1.5 text-sm" data-testid={`${p}-stops-list`}>
      {stops.map((s, idx) => (
        <li
          key={s.id}
          className="flex items-center gap-2 bg-white rounded border border-slate-200 p-2 min-w-0 overflow-hidden"
          data-testid={`${p}-stop-${idx}`}
        >
          <span className="text-xs text-slate-400 tabular-nums w-5 shrink-0">{idx + 1}.</span>
          <div className="flex-1 min-w-0 overflow-hidden">
            {onStopClick ? (
              <button
                type="button"
                onClick={() => onStopClick(s.id)}
                className="block w-full truncate text-left text-slate-900 text-sm font-medium hover:text-[hsl(var(--brand))] hover:underline underline-offset-2 transition-colors"
                title="Open details"
                data-testid={`${p}-stop-title-${idx}`}
              >
                {s.title || "—"}
              </button>
            ) : (
              <div className="truncate text-slate-900 text-sm">{s.title || "—"}</div>
            )}
            {s.subtitle ? <div className="text-xs text-slate-500 truncate">{s.subtitle}</div> : null}
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <button
              type="button"
              onClick={() => onReorder && onReorder(idx, idx - 1)}
              disabled={idx === 0}
              className={`${iconBtn} border-slate-200`}
              aria-label="Move up"
              data-testid={`${p}-stop-up-${idx}`}
            >
              <ArrowUp className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => onReorder && onReorder(idx, idx + 1)}
              disabled={idx === stops.length - 1}
              className={`${iconBtn} border-slate-200`}
              aria-label="Move down"
              data-testid={`${p}-stop-down-${idx}`}
            >
              <ArrowDown className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => onRemoveStop && onRemoveStop(s.id)}
              className={`${iconBtn} border-red-200 text-red-600 hover:bg-red-50`}
              aria-label="Remove from route"
              data-testid={`${p}-stop-remove-${idx}`}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </li>
      ))}
    </ol>
  );
}
